export default __webpack_public_path__ + "static/media/11.9ca6c634.jpeg";